import { __assign } from "tslib";
import { UserBuilder } from '../user-builder';
import { PermissionLevel } from '../permission-level.enum';
import { AgentStatus } from './agent-status.enum';
import { AgentChannel } from './agent-channel.enum';
import { CallCenterAgentStatus } from '../callcenter-agent';
var AgentBuilder = /** @class */ (function () {
    function AgentBuilder() {
        var baseUser = new UserBuilder().build();
        this.agent = __assign(__assign({}, baseUser), { isAgent: true, permissionLevel: PermissionLevel.AGENT, location: 'SF', groupIds: [], queueIds: [], callCenter: false, callCenterId: '', agentCreationDate: baseUser.creationDate, agentLastUpdateDate: baseUser.lastUpdateDate, agentStatus: AgentStatus.ONLINE, channel: AgentChannel.NONE, callCenterStatus: CallCenterAgentStatus.OFFLINE, activeChatTicketIds: [], numberOfActiveChats: 0, interfaceLocale: 'en', customFields: {}, email: '' });
    }
    AgentBuilder.prototype.withUserId = function (id) {
        this.agent.id = id;
        return this;
    };
    AgentBuilder.prototype.withFullName = function (fullName) {
        this.agent.fullName = fullName;
        return this;
    };
    AgentBuilder.prototype.withFirstName = function (firstName) {
        this.agent.firstName = firstName;
        return this;
    };
    AgentBuilder.prototype.withLastName = function (lastName) {
        this.agent.lastName = lastName;
        return this;
    };
    AgentBuilder.prototype.withProfileImage = function (profileImage) {
        this.agent.profileImage = profileImage;
        return this;
    };
    AgentBuilder.prototype.withLocation = function (location) {
        this.agent.location = location;
        return this;
    };
    AgentBuilder.prototype.withGroupIds = function (groupIds) {
        this.agent.groupIds = groupIds;
        return this;
    };
    AgentBuilder.prototype.withQueueIds = function (queueIds) {
        this.agent.queueIds = queueIds;
        return this;
    };
    AgentBuilder.prototype.withSkillIds = function (skillIds) {
        this.agent.skillIds = skillIds;
        return this;
    };
    AgentBuilder.prototype.withPermissionLevel = function (permissionLevel) {
        this.agent.permissionLevel = permissionLevel;
        return this;
    };
    AgentBuilder.prototype.withAgentStatus = function (agentStatus) {
        this.agent.agentStatus = agentStatus;
        return this;
    };
    AgentBuilder.prototype.withChannel = function (channel) {
        this.agent.channel = channel;
        return this;
    };
    AgentBuilder.prototype.withActiveChatTicketIds = function (activeChatTicketIds) {
        this.agent.activeChatTicketIds = activeChatTicketIds;
        return this;
    };
    AgentBuilder.prototype.withNumberOfActiveChats = function (numberOfActiveChats) {
        this.agent.numberOfActiveChats = numberOfActiveChats;
        return this;
    };
    AgentBuilder.prototype.withCallCenterAgentStatus = function (callCenterStatus) {
        this.agent.callCenterStatus = callCenterStatus;
        return this;
    };
    AgentBuilder.prototype.withStatusStartDate = function () {
        var now = Date.now() - 3600;
        this.agent.statusStartDate = now;
        this.agent.callCenterStatusStartDate = now;
        return this;
    };
    AgentBuilder.prototype.withRoleId = function (roleId) {
        this.agent.roleId = roleId;
        return this;
    };
    AgentBuilder.prototype.withManagerId = function (managerId) {
        this.agent.managerId = managerId;
        return this;
    };
    AgentBuilder.prototype.withJobTitle = function (jobTitle) {
        this.agent.jobTitle = jobTitle;
        return this;
    };
    AgentBuilder.prototype.withLocationId = function (locationId) {
        this.agent.locationId = locationId;
        return this;
    };
    AgentBuilder.prototype.withTeamId = function (teamId) {
        this.agent.teamId = teamId;
        return this;
    };
    AgentBuilder.prototype.withLocales = function (locales) {
        this.agent.locales = locales;
        return this;
    };
    AgentBuilder.prototype.withQualifiedChannels = function (qualifiedChannels) {
        this.agent.qualifiedChannels = qualifiedChannels;
        return this;
    };
    AgentBuilder.prototype.withActive = function (active) {
        this.agent.active = active;
        return this;
    };
    AgentBuilder.prototype.withWrapUpTicketId = function (wrapUpTicketId) {
        this.agent.wrapUpTicketId = wrapUpTicketId;
        return this;
    };
    AgentBuilder.prototype.withAutoRoutingSettings = function (agentAutoRoutingSettings) {
        this.agent.autoRoutingSettings = agentAutoRoutingSettings;
        return this;
    };
    AgentBuilder.prototype.withInterfaceLocale = function (locale) {
        this.agent.interfaceLocale = locale;
        return this;
    };
    AgentBuilder.prototype.withCustomFields = function (customFields) {
        this.agent.customFields = customFields;
        return this;
    };
    AgentBuilder.prototype.withUserEmail = function (userEmail) {
        this.agent.email = userEmail;
        return this;
    };
    AgentBuilder.prototype.withSignature = function (signature) {
        this.agent.signature = signature;
        return this;
    };
    AgentBuilder.prototype.withSlackChannel = function (slackChannel) {
        this.agent.slackChannel = slackChannel;
        return this;
    };
    AgentBuilder.prototype.withAgentCreationDate = function (agentCreationDate) {
        this.agent.agentCreationDate = agentCreationDate;
        return this;
    };
    AgentBuilder.prototype.withAgentActivity = function (agentActivity) {
        var defaultAgentActivity = {
            activeTicketIds: [],
            activeChatIds: [],
            activeCallIds: [],
            activeWhatsappIds: [],
            activeFacebookIds: [],
            activeSmsIds: [],
            activeTwitterIds: [],
            activeInstagramIds: [],
            lastRoutingDate: 0,
        };
        this.agent.agentActivity = __assign(__assign({}, defaultAgentActivity), agentActivity);
        return this;
    };
    AgentBuilder.prototype.build = function () {
        return this.agent;
    };
    return AgentBuilder;
}());
export { AgentBuilder };
//# sourceMappingURL=agent.builder.js.map